import { Link } from 'react-router-dom'

import { Badge } from './ui.tsx'
import { moneyIn, pnl, pnlClass } from '../lib/format.ts'
import type { RoundStatus, RoundView } from '../../shared/types.ts'

function date(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}

export function RoundBadge({ status }: { status: RoundStatus }) {
  if (status === 'bust') return <Badge tone="neg">Went to zero</Badge>
  if (status === 'active') return <Badge tone="teal" dot>Current</Badge>
  if (status === 'settling') return <Badge tone="warn">Settling</Badge>
  return <Badge tone="skipped">Closed</Badge>
}

/**
 * A player's rounds, newest first. The same table on their own Bankroll page and on their
 * public one; `ownBets` — their own page only — links each round to its bets on P&L.
 */
export function RoundsTable({ rounds, ownBets = false }: { rounds: RoundView[]; ownBets?: boolean }) {
  return (
    <div className="table-wrap">
      <table className="tbl">
        <thead>
          <tr>
            <th>Round</th>
            <th>Started</th>
            <th>Ended</th>
            <th>Bets</th>
            <th>Status</th>
            <th className="num">Balance</th>
            <th className="num">Profit</th>
            {ownBets && <th />}
          </tr>
        </thead>
        <tbody>
          {rounds.map((r) => (
            <tr key={r.number}>
              <td className="cell-strong">
                {r.number}
              </td>
              <td className="u-sm">{date(r.startedAt)}</td>
              <td className="u-sm">{r.endedAt ? date(r.endedAt) : '—'}</td>
              <td className="u-mono">
                {r.settledBets}
                {r.openBets ? <span className="cell-sub"> + {r.openBets} open</span> : null}
              </td>
              <td>
                <RoundBadge status={r.status} />
              </td>
              <td className="num u-mono">{moneyIn(r.balance, r.currency)}</td>
              <td className={`num u-mono ${pnlClass(r.balance - r.startingBalance)}`}>
                {pnl(r.balance - r.startingBalance, r.currency)}
              </td>
              {ownBets && (
                <td className="num">
                  <Link className="btn ghost sm" to={`/pnl?round=${r.number}&range=all`}>
                    View bets →
                  </Link>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
